import React from "react"
import CookieBanner from "./CookieBanner"
import CookiePreferencesModal from "./CookiePreferencesModal"
import useConsent from "../../hooks/useConsent"
import {
  OPEN_PREFERENCES_EVENT,
  PreferencesFocus,
} from "../../utils/consent"

export default function CookieConsent() {
  const { consent, hasChosen, gpc, setConsent } = useConsent()
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [focus, setFocus] = React.useState<PreferencesFocus | undefined>()

  React.useEffect(() => {
    const open = (event: Event) => {
      setFocus((event as CustomEvent).detail?.focus)
      setIsModalOpen(true)
    }
    window.addEventListener(OPEN_PREFERENCES_EVENT, open)
    return () => window.removeEventListener(OPEN_PREFERENCES_EVENT, open)
  }, [])

  return (
    <>
      {!hasChosen && !gpc && !isModalOpen && (
        <CookieBanner
          onAccept={() => setConsent({ analytics: true, marketing: true })}
          onOptOut={() => setConsent({ analytics: false, marketing: false })}
          onManage={() => {
            setFocus(undefined)
            setIsModalOpen(true)
          }}
        />
      )}
      <CookiePreferencesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        consent={consent}
        gpc={gpc}
        focus={focus}
        onSave={(next) => {
          setIsModalOpen(false)
          setConsent(next)
        }}
      />
    </>
  )
}
